<div class="field--paired-container field--compact">
    <div class="compact-item">
        <div class="ui calendar" id="dateStart">
            <div class="ui input left icon">
                <i class="calendar icon blue"></i>
                <input type="text" placeholder="Start" [ngModel]="dateStart | date: dateFormat" />
            </div>
        </div>
    </div>
    <div class="divider">to</div>
    <div class="compact-item">
        <div class="ui calendar" id="dateEnd">
            <div class="ui input left icon">
                <i class="calendar icon blue"></i>
                <input type="text" placeholder="End" [ngModel]="dateEnd | date: dateFormat" />
            </div>
        </div>
    </div>
</div>
